import { render } from "./BusinessCompanyClients.vue?vue&type=template&id=5fe2b258"
import script from "./BusinessCompanyClients.vue?vue&type=script&lang=js"
export * from "./BusinessCompanyClients.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__